import type { ReactNode } from 'react'
import { Flag, Image, Tag, Type as TypeIcon } from 'lucide-react'
import type { Overlay } from '@shared/types'

/**
 * UI MK2 第2段 2b: 「要素」一覧・複数選択の内訳・各 OverlayInspector のヘッダーで
 * 共通して使う種類名/アイコン/要約テキスト。3ヶ所で同じ Record を書き直さないための
 * 唯一の置き場（このファイルは ControlPanel/** の内側なので所有権は 2b のまま）。
 */
export const OVERLAY_KIND_LABEL: Record<Overlay['kind'], string> = {
  title: 'タイトル',
  label: 'ラベル',
  end: '終了カード',
  logo: 'ロゴ',
  free: 'テキスト',
}

export const OVERLAY_KIND_ICON: Record<Overlay['kind'], ReactNode> = {
  title: <TypeIcon size={13} />,
  label: <Tag size={13} />,
  end: <Flag size={13} />,
  logo: <Image size={13} />,
  free: <TypeIcon size={13} />,
}

/** 「要素」一覧の各行に出す要約テキスト。 */
export function overlaySummary(o: Overlay): string {
  switch (o.kind) {
    case 'title':
      return o.text || '(無題)'
    case 'label':
      return o.ja || '(無題)'
    case 'end':
      return o.lines.filter(Boolean).join(' / ') || '(内容未設定)'
    case 'logo':
      return '常時表示・位置固定'
    case 'free':
      return o.text || '(無題)'
  }
}
